import React from 'react';

import { EMOTION_OPTIONS } from '@vlabs/api-bindings/src/constants';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CheckboxCustomFilter } from '../components/checkbox-custom-filter/CheckboxCustomFilter';
import { CustomFilterPopover } from '../components/CustomFilterPopover';
import { useFilterCount } from '../hooks';

export const EmotionsCheckboxesPopover = ({ onCountChange = undefined }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const selectedEmotions = useWatch({ name: 'emotions' });
  const filterCount = Array.isArray(selectedEmotions) && selectedEmotions.length > 0 ? 1 : 0;
  useFilterCount('emotions', filterCount, onCountChange);

  return (
    <CustomFilterPopover
      hasFilterValue={Boolean(filterCount)}
      testId="emotionsFilter"
      triggerValue={t('emotion')}
    >
      <CheckboxCustomFilter
        control={control}
        isMulti
        name="emotions"
        options={EMOTION_OPTIONS.raw}
      />
    </CustomFilterPopover>
  );
};
